// import React from 'react'

// import { useState } from "react"
// import { ChevronDown, Eye, EyeOff, HelpCircle, Globe } from "lucide-react"
// import { useNavigate } from "react-router-dom";

// import styles from "../../styles/__login.module.scss"
// import Footer from "../../components/footer/Footer";
// import { useTranslation } from "react-i18next";

// const ResetPassword = () => {
// const navigate = useNavigate();
//  const { t, i18n } = useTranslation();
//   const [showPassword, setShowPassword] = useState(false)
//   const [selectedRole, setSelectedRole] = useState("Doctor")
//   const [selectedCountry, setSelectedCountry] = useState("+20")
//   const [mobileNumber, setMobileNumber] = useState("")
//   const [password, setPassword] = useState("")
//   const [conformPassword, setConformPassword] = useState("")

// const countries = [
//     { code: "+964", flag: "/flags/Flag_of_Iraq-64x43.png", name: "Iraq" },
//     { code: "+20", flag: "/flags/Flag_of_Egypt-64x43.png", name: "Egypt" },
//     { code: "+1", flag: "/flags/Flag_of_United_States-64x34.png", name: "United States" }
// ]
// const selectedCountryData = countries.find((country) => country.code === selectedCountry) || countries[0]

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Login attempt:", { selectedRole, selectedCountry, mobileNumber, password });

//     navigate(`/`);
//   };

//   return (
//     <div className={`${styles["main-container"]}`}>

//       {/* Main Content */}
//       <main className={`${styles["main-content"]}`}>
//         <div className={`${styles["content-wrapper"]}`}>
//           {/* Doctor Illustration */}
//           <div className={`${styles["illustration"]}`}>
//             <div className={`${styles["doctor-illustration"]}`}>
//               <img src="/ForgotPassword.png" alt="Doctor illustration" className={`${styles["doctor-image"]}`} />
//             </div>
//           </div>

//           {/* Login Form */}
//           <div className={`${styles["login-form-container"]}`}>
//             <h2>{t('loginToAccount')}</h2>
//             <form onSubmit={handleSubmit} className={`${styles["login-form"]}`}>

//               {/* Mobile Number */}
//               <div className={`${styles["form-group"]}`}>
//                 <label htmlFor="mobile">{t('mobileNumber')}</label>
//                 <div className={`${styles["mobile-input-container"]}`}>
//                   <div className={`${styles["country-selector"]}`}>
//                     <span className={`${styles["selected-flag"]}`}>
//                         <img src={selectedCountryData.flag} alt="" />
//                     </span>
//                     <select
//                       value={selectedCountry}
//                       onChange={(e) => setSelectedCountry(e.target.value)}
//                       className={`${styles["country-dropdown"]}`}
//                     >
//                       {countries.map((country) => (
//                         <option key={country.code} value={country.code}>
//                         {country.code} {country.name}
//                         </option>
//                       ))}
//                     </select>
//                     <ChevronDown size={14} className={`${styles["dropdown-arrow"]}`} />
//                   </div>
//                   <input
//                     type="tel"
//                     id="mobile"
//                     placeholder="770 123 4567"
//                     value={mobileNumber}
//                     onChange={(e) => setMobileNumber(e.target.value)}
//                     className={`${styles["phone-input"]}`}
//                   />
//                 </div>
//               </div>

//               {/* Password */}
//               <div className={`${styles["form-group"]}`}>
//                 <label htmlFor="password">{t('newPassword')}</label>
//                 <div className={`${styles["password-wrapper"]}`}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className={`${styles["form-input"]}`}
//                   />
//                   <button type="button" onClick={() => setShowPassword(!showPassword)} className={`${styles["password-toggle"]}`}>
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               {/* Confirm Password */}
//               <div className={`${styles["form-group"]}`}>
//                 <label htmlFor="password">{t('confirmPassword')}</label>
//                 <div className={`${styles["password-wrapper"]}`}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••••"
//                     value={conformPassword}
//                     onChange={(e) => setConformPassword(e.target.value)}
//                     className={`${styles["form-input"]}`}
//                   />
//                   <button type="button" onClick={() => setShowPassword(!conformPassword)} className={`${styles["password-toggle"]}`}>
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               {/* Login Button */}
//               <button type="submit" className={`${styles["login-btn"]}`}>
//                 {t('resetPassword')}
//               </button>
//             </form>
//           </div>
//         </div>
//       </main>

//       <Footer />
//     </div>
//   )
// }

// export default ResetPassword

// import React, { useState } from "react";
// import { ChevronDown, Eye, EyeOff } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import styles from "../../styles/__login.module.scss";
// import Footer from "../../components/footer/Footer";

// const ResetPassword = () => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const [showPassword, setShowPassword] = useState(false);
//   const [selectedCountry, setSelectedCountry] = useState("+20");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [errors, setErrors] = useState({});

//   const countries = [
//     { code: "+964", flag: "/flags/Flag_of_Iraq-64x43.png", name: "Iraq" },
//     { code: "+20", flag: "/flags/Flag_of_Egypt-64x43.png", name: "Egypt" },
//     { code: "+1", flag: "/flags/Flag_of_United_States-64x34.png", name: "United States" },
//   ];

//   const selectedCountryData =
//     countries.find((country) => country.code === selectedCountry) || countries[0];

//   // Password pattern: At least 8 characters, one uppercase, one lowercase, one number, one special character
//   const passwordPattern =
//     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//   const validateForm = () => {
//     const newErrors = {};

//     // Mobile validation
//     if (!mobileNumber.trim()) {
//       newErrors.mobileNumber = "Please enter your mobile number.";
//     } else if (!/^[0-9]{7,15}$/.test(mobileNumber)) {
//       newErrors.mobileNumber = "Please enter a valid mobile number.";
//     }

//     // Password validation
//     if (!password) {
//       newErrors.password = "Please enter your new password.";
//     } else if (!passwordPattern.test(password)) {
//       newErrors.password =
//         "Password must be at least 8 characters long, include one uppercase, one lowercase, one number, and one special character.";
//     }

//     // Confirm password validation
//     if (!confirmPassword) {
//       newErrors.confirmPassword = "Please confirm your password.";
//     } else if (password !== confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match.";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     console.log("Password reset details:", {
//       selectedCountry,
//       mobileNumber,
//       password,
//     });

//     alert("Password reset successful!");
//     navigate("/");
//   };

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["content-wrapper"]}>
//           {/* Illustration */}
//           <div className={styles["illustration"]}>
//             <div className={styles["doctor-illustration"]}>
//               <img
//                 src="/ForgotPassword.png"
//                 alt="Doctor illustration"
//                 className={styles["doctor-image"]}
//               />
//             </div>
//           </div>

//           {/* Reset Password Form */}
//           <div className={styles["login-form-container"]}>
//             <h2>{t("resetPassword")}</h2>

//             <form onSubmit={handleSubmit} className={styles["login-form"]}>
//               {/* Mobile Number */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="mobile">{t("mobileNumber")}</label>
//                 <div className={styles["mobile-input-container"]}>
//                   <div className={styles["country-selector"]}>
//                     <span className={styles["selected-flag"]}>
//                       <img src={selectedCountryData.flag} alt="" />
//                     </span>
//                     <select
//                       value={selectedCountry}
//                       onChange={(e) => setSelectedCountry(e.target.value)}
//                       className={styles["country-dropdown"]}
//                     >
//                       {countries.map((country) => (
//                         <option key={country.code} value={country.code}>
//                           {country.code} {country.name}
//                         </option>
//                       ))}
//                     </select>
//                     <ChevronDown size={14} className={styles["dropdown-arrow"]} />
//                   </div>
//                   <input
//                     type="tel"
//                     id="mobile"
//                     placeholder="770 123 4567"
//                     value={mobileNumber}
//                     onChange={(e) => setMobileNumber(e.target.value)}
//                     className={`${styles["phone-input"]} ${
//                       errors.mobileNumber ? styles["input-error"] : ""
//                     }`}
//                   />
//                 </div>
//                 {errors.mobileNumber && (
//                   <p className={styles["error-message"]}>{errors.mobileNumber}</p>
//                 )}
//               </div>

//               {/* New Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="password">{t("newPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className={`${styles["form-input"]} ${
//                       errors.password ? styles["input-error"] : ""
//                     }`}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {/* Password Rules Display */}
//                 <ul className={styles["password-rules"]}>
//                   <li className={password.length >= 8 ? styles["valid"] : ""}>
//                     At least 8 characters
//                   </li>
//                   <li className={/[a-z]/.test(password) ? styles["valid"] : ""}>
//                     At least one lowercase letter
//                   </li>
//                   <li className={/[A-Z]/.test(password) ? styles["valid"] : ""}>
//                     At least one uppercase letter
//                   </li>
//                   <li className={/\d/.test(password) ? styles["valid"] : ""}>
//                     At least one number
//                   </li>
//                   <li className={/[@$!%*?&]/.test(password) ? styles["valid"] : ""}>
//                     At least one special character
//                   </li>
//                 </ul>

//                 {errors.password && (
//                   <p className={styles["error-message"]}>{errors.password}</p>
//                 )}
//               </div>

//               {/* Confirm Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="confirmPassword"
//                     placeholder="••••••••••"
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                     className={`${styles["form-input"]} ${
//                       errors.confirmPassword ? styles["input-error"] : ""
//                     }`}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//                 {errors.confirmPassword && (
//                   <p className={styles["error-message"]}>
//                     {errors.confirmPassword}
//                   </p>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <button type="submit" className={styles["login-btn"]}>
//                 {t("resetPassword")}
//               </button>
//             </form>
//           </div>
//         </div>
//       </main>
//       <Footer />
//     </div>
//   );
// };

// export default ResetPassword;

// import React, { useState } from "react";
// import { ChevronDown, Eye, EyeOff } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import styles from "../../styles/__login.module.scss";
// import Footer from "../../components/footer/Footer";

// const ResetPassword = () => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const [showPasswordOld, setShowPasswordOld] = useState(false);
//   const [showPasswordNew, setShowPasswordNew] = useState(false);
//   const [showPasswordCon, setShowPasswordCon] = useState(false);

//   const [oldPassword, setOldPassword] = useState("")
//   const [selectedCountry, setSelectedCountry] = useState("+20");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [errors, setErrors] = useState({});

//   const countries = [
//     { code: "+964", flag: "/flags/Flag_of_Iraq-64x43.png", name: "Iraq" },
//     { code: "+20", flag: "/flags/Flag_of_Egypt-64x43.png", name: "Egypt" },
//     { code: "+1", flag: "/flags/Flag_of_United_States-64x34.png", name: "United States" },
//   ];

//   const selectedCountryData =
//     countries.find((country) => country.code === selectedCountry) || countries[0];

//   // ✅ Password rules definition
//   const passwordRules = {
//     length: { test: (pwd) => pwd.length >= 8, message: "At least 8 characters" },
//     lowercase: { test: (pwd) => /[a-z]/.test(pwd), message: "At least one lowercase letter" },
//     uppercase: { test: (pwd) => /[A-Z]/.test(pwd), message: "At least one uppercase letter" },
//     number: { test: (pwd) => /[0-9]/.test(pwd), message: "At least one number" },
//     special: {
//       test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
//       message: "At least one special character",
//     },
//   };

//   // ✅ Validation function
//   const validateForm = () => {
//     const newErrors = {};

//     // Mobile number validation
//     if (!mobileNumber.trim()) {
//       newErrors.mobileNumber = "Mobile number is required";
//     } else if (!/^\d{7,15}$/.test(mobileNumber)) {
//       newErrors.mobileNumber = "Enter a valid mobile number";
//     }

//     // Password validation
//     if (!password.trim()) {
//       newErrors.password = "Password is required";
//     } else {
//       const failedRule = Object.values(passwordRules).find((rule) => !rule.test(password));
//       if (failedRule) newErrors.password = failedRule.message;
//     }

//     // Confirm password validation
//     if (!confirmPassword.trim()) {
//       newErrors.confirmPassword = "Confirm password is required";
//     } else if (password !== confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ✅ Form submit
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     console.log("Reset Password Data:", {
//       selectedCountry,
//       mobileNumber,
//       password,
//     });

//     navigate("/"); // Redirect to login or home page
//   };

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["content-wrapper"]}>
//           {/* Illustration */}
//           <div className={styles["illustration"]}>
//             <div className={styles["doctor-illustration"]}>
//               <img
//                 src="/ForgotPassword.png"
//                 alt="Doctor illustration"
//                 className={styles["doctor-image"]}
//               />
//             </div>
//           </div>

//           {/* Reset Password Form */}
//           <div className={styles["login-form-container"]}>
//             <h2>{t("resetPassword")}</h2>

//             <form onSubmit={handleSubmit} className={styles["login-form"]}>
//               {/* Mobile Number */}
//               {/* <div className={styles["form-group"]}>
//                 <label htmlFor="mobile">{t("mobileNumber")}</label>
//                 <div className={styles["mobile-input-container"]}>
//                   <div className={styles["country-selector"]}>
//                     <span className={styles["selected-flag"]}>
//                       <img src={selectedCountryData.flag} alt="" />
//                     </span>
//                     <select
//                       value={selectedCountry}
//                       onChange={(e) => setSelectedCountry(e.target.value)}
//                       className={styles["country-dropdown"]}
//                     >
//                       {countries.map((country) => (
//                         <option key={country.code} value={country.code}>
//                           {country.code} {country.name}
//                         </option>
//                       ))}
//                     </select>
//                     <ChevronDown size={14} className={styles["dropdown-arrow"]} />
//                   </div>
//                   <input
//                     type="tel"
//                     id="mobile"
//                     placeholder="770 123 4567"
//                     value={mobileNumber}
//                     onChange={(e) => setMobileNumber(e.target.value)}
//                     className={styles["phone-input"]}
//                   />
//                 </div>
//                 {errors.mobileNumber && (
//                   <p className={styles["rule-invalid"]}>{errors.mobileNumber}</p>
//                 )}
//               </div> */}

//               {/*old password*/}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="password">{t("oldPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordOld ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••••"
//                     value={oldPassword}
//                     onChange={(e) => setOldPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordOld(!showPasswordOld)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordOld ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {/* Password rule indicators */}

//                 {errors.password && (
//                   <p className={styles["rule-invalid"]}>{errors.password}</p>
//                 )}
//               </div>

//               {/* New Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="password">{t("newPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordNew ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordNew(!showPasswordNew)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordNew ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {/* Password rule indicators */}
//                 <div className={styles["password-rules"]}>
//                   {Object.keys(passwordRules).map((ruleKey) => {
//                     const rule = passwordRules[ruleKey];
//                     const isValid = rule.test(password);
//                     return (
//                       <p
//                         key={ruleKey}
//                         className={isValid ? styles["rule-valid"] : styles["rule-invalid"]}
//                       >
//                         {isValid ? "✔" : "✖"} {rule.message}
//                       </p>
//                     );
//                   })}
//                 </div>

//                 {errors.password && (
//                   <p className={styles["rule-invalid"]}>{errors.password}</p>
//                 )}
//               </div>

//               {/* Confirm Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordCon ? "text" : "password"}
//                     id="confirmPassword"
//                     placeholder="••••••••••"
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordCon(!showPasswordCon)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordCon ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//                 {errors.confirmPassword && (
//                   <p className={styles["rule-invalid"]}>{errors.confirmPassword}</p>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <button type="submit" className={styles["login-btn"]}>
//                 {t("resetPassword")}
//               </button>
//             </form>
//           </div>
//         </div>
//       </main>

//       <Footer />
//     </div>
//   );
// };

// export default ResetPassword;

// import React, { useState } from "react";
// import { ChevronDown, Eye, EyeOff } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import styles from "../../styles/__login.module.scss";
// import Footer from "../../components/footer/Footer";

// const ResetPassword = () => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const [showPasswordOld, setShowPasswordOld] = useState(false);
//   const [showPasswordNew, setShowPasswordNew] = useState(false);
//   const [showPasswordCon, setShowPasswordCon] = useState(false);

//   const [oldPassword, setOldPassword] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [errors, setErrors] = useState({});

//   // ✅ Password rules
//   const passwordRules = {
//     length: { test: (pwd) => pwd.length >= 8, message: "At least 8 characters" },
//     lowercase: { test: (pwd) => /[a-z]/.test(pwd), message: "At least one lowercase letter" },
//     uppercase: { test: (pwd) => /[A-Z]/.test(pwd), message: "At least one uppercase letter" },
//     number: { test: (pwd) => /[0-9]/.test(pwd), message: "At least one number" },
//     special: {
//       test: (pwd) => /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
//       message: "At least one special character",
//     },
//   };

//   // ✅ Validation function
//   const validateForm = () => {
//     const newErrors = {};

//     // Old password validation
//     if (!oldPassword.trim()) {
//       newErrors.oldPassword = "Old password is required";
//     } else {
//       const failedRule = Object.values(passwordRules).find((rule) => !rule.test(oldPassword));
//       if (failedRule) newErrors.oldPassword = failedRule.message;
//     }

//     // New password validation
//     if (!password.trim()) {
//       newErrors.password = "New password is required";
//     } else {
//       const failedRule = Object.values(passwordRules).find((rule) => !rule.test(password));
//       if (failedRule) newErrors.password = failedRule.message;
//     }

//     // Confirm password validation
//     if (!confirmPassword.trim()) {
//       newErrors.confirmPassword = "Confirm password is required";
//     } else if (password !== confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ✅ Handle Submit
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
// const payload = {
//       oldPassword,
//       password,
//       confirmPassword,
//     };
//     console.log("Reset Password Data:", {
//       oldPassword,
//       password,
//       confirmPassword,
//     });

//     navigate("/"); // Redirect after success
//   };

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["content-wrapper"]}>
//           {/* Illustration */}
//           <div className={styles["illustration"]}>
//             <div className={styles["doctor-illustration"]}>
//               <img
//                 src="/ForgotPassword.png"
//                 alt="Doctor illustration"
//                 className={styles["doctor-image"]}
//               />
//             </div>
//           </div>

//           {/* Reset Password Form */}
//           <div className={styles["login-form-container"]}>
//             <h2>{t("resetPassword")}</h2>

//             <form onSubmit={handleSubmit} className={styles["login-form"]}>
//               {/* Old Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="oldPassword">{t("oldPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordOld ? "text" : "password"}
//                     id="oldPassword"
//                     placeholder="••••••••"
//                     value={oldPassword}
//                     onChange={(e) => setOldPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordOld(!showPasswordOld)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordOld ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {/* Password rule indicators for old password */}
//                 <div className={styles["password-rules"]}>
//                   {Object.keys(passwordRules).map((ruleKey) => {
//                     const rule = passwordRules[ruleKey];
//                     const isValid = rule.test(oldPassword);
//                     return (
//                       <p
//                         key={ruleKey}
//                         className={isValid ? styles["rule-valid"] : styles["rule-invalid"]}
//                       >
//                         {isValid ? "✔" : "✖"} {rule.message}
//                       </p>
//                     );
//                   })}
//                 </div>

//                 {errors.oldPassword && (
//                   <p className={styles["rule-invalid"]}>{errors.oldPassword}</p>
//                 )}
//               </div>

//               {/* New Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="password">{t("newPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordNew ? "text" : "password"}
//                     id="password"
//                     placeholder="••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordNew(!showPasswordNew)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordNew ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {/* Password rule indicators */}
//                 <div className={styles["password-rules"]}>
//                   {Object.keys(passwordRules).map((ruleKey) => {
//                     const rule = passwordRules[ruleKey];
//                     const isValid = rule.test(password);
//                     return (
//                       <p
//                         key={ruleKey}
//                         className={isValid ? styles["rule-valid"] : styles["rule-invalid"]}
//                       >
//                         {isValid ? "✔" : "✖"} {rule.message}
//                       </p>
//                     );
//                   })}
//                 </div>

//                 {errors.password && (
//                   <p className={styles["rule-invalid"]}>{errors.password}</p>
//                 )}
//               </div>

//               {/* Confirm Password */}
//               <div className={styles["form-group"]}>
//                 <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
//                 <div className={styles["password-wrapper"]}>
//                   <input
//                     type={showPasswordCon ? "text" : "password"}
//                     id="confirmPassword"
//                     placeholder="••••••••"
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                     className={styles["form-input"]}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPasswordCon(!showPasswordCon)}
//                     className={styles["password-toggle"]}
//                   >
//                     {showPasswordCon ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//                 {errors.confirmPassword && (
//                   <p className={styles["rule-invalid"]}>{errors.confirmPassword}</p>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <button type="submit" className={styles["login-btn"]}>
//                 {t("resetPassword")}
//               </button>
//             </form>
//           </div>
//         </div>
//       </main>

//       <Footer />
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "../../styles/__login.module.scss";
import Footer from "../../components/footer/Footer";
import { useDispatch } from "react-redux";
import { postResetPassword } from "../../reducer/resetPassword/resetPasswordReducer";
import { useLocation } from "react-router-dom"; // ✅ Get reset token from URL params

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordCon, setShowPasswordCon] = useState(false);
  const token = queryParams.get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  console.log("token:", token);

  // ✅ Password rules
  const passwordRules = {
    length: {
      test: (pwd) => pwd.length >= 8,
      message: t("charcters-8"),
    },
    lowercase: {
      test: (pwd) => /[a-z]/.test(pwd),
      message: t("lowerCase"),
    },
    uppercase: {
      test: (pwd) => /[A-Z]/.test(pwd),
      message: t("upperCase"),
    },
    number: {
      test: (pwd) => /[0-9]/.test(pwd),
      message: t("oneNumber"),
    },
    special: {
      test: (pwd) => /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
      message: t("specialCharacter"),
    },
  };

  // ✅ Validation function
  const validateForm = () => {
    const newErrors = {};

    // New password validation
    if (!password.trim()) {
      newErrors.password = t("resetPassword.validation.newPasswordRequired");
    } else {
      const failedRule = Object.values(passwordRules).find(
        (rule) => !rule.test(password),
      );
      if (failedRule) newErrors.password = failedRule.message;
    }

    // Confirm password validation
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = t(
        "resetPassword.validation.confirmPasswordRequired",
      );
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = t("resetPassword.validation.passwordsMismatch");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      new_password: password,
      confirm_password: confirmPassword,
      reset_token: token, // ✅ Now included from params
    };
    dispatch(postResetPassword(payload));

    console.log("Reset Password Data:", payload);

    // API call can go here using Redux or fetch
    // navigate("/"); // Redirect after success
  };

  return (
    <div className={styles["main-container"]}>
      <main className={styles["main-content"]}>
        <div className={styles["content-wrapper"]}>
          {/* Illustration */}
          <div className={styles["illustration"]}>
            <div className={styles["doctor-illustration"]}>
              <img
                src="/ForgotPassword.png"
                alt={t("resetPassword.illustrationAlt")}
                className={styles["doctor-image"]}
              />
            </div>
          </div>

          {/* Reset Password Form */}
          <div className={styles["login-form-container"]}>
            <h2>{t("resetPassword")}</h2>

            <form onSubmit={handleSubmit} className={styles["login-form"]}>
              {/* New Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="password">{t("newPassword")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPasswordNew ? "text" : "password"}
                    id="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswordNew(!showPasswordNew)}
                    className={styles["password-toggle"]}
                  >
                    {showPasswordNew ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>

                {/* Password rule indicators */}
                <div className={styles["password-rules"]}>
                  {Object.keys(passwordRules).map((ruleKey) => {
                    const rule = passwordRules[ruleKey];
                    const isValid = rule.test(password);
                    return (
                      <p
                        key={ruleKey}
                        className={
                          isValid
                            ? styles["rule-valid"]
                            : styles["rule-invalid"]
                        }
                      >
                        {isValid ? "✔" : "✖"} {rule.message}
                      </p>
                    );
                  })}
                </div>

                {errors.password && (
                  <p className={styles["rule-invalid"]}>{errors.password}</p>
                )}
              </div>

              {/* Confirm Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPasswordCon ? "text" : "password"}
                    id="confirmPassword"
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswordCon(!showPasswordCon)}
                    className={styles["password-toggle"]}
                  >
                    {showPasswordCon ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {errors.confirmPassword && (
                  <p className={styles["rule-invalid"]}>
                    {errors.confirmPassword}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              <button type="submit" className={styles["login-btn"]}>
                {t("resetPassword")}
              </button>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ResetPassword;
